











import { Component, Vue } from "vue-property-decorator";

import GlobalFooter from "@/components/layout/GlobalFooter.vue";
import GlobalHeader from "@/components/layout/GlobalHeader.vue";
import GlobalLoading from "@/components/layout/GlobalLoading.vue";

@Component({
  components: { GlobalLoading, GlobalFooter, GlobalHeader },
})
export default class App extends Vue {}
